export default __webpack_public_path__ + "static/media/3247.5e119698.png";